import { GenericParamFields, ParamFormRow } from "entity/Indicador/components/ParamFields"
import TextInput from "components/form/input/TextInput"
import PSM from ".."

export function PSMParamFields({ tipoIndicadorField }) {
    return (
        <GenericParamFields
            name={PSM.field + tipoIndicadorField}
            bottomFields={
                <>
                    <ParamFormRow label="Meta (%)">
                        <TextInput name="manual.meta" label="Meta (%)" type="number" />
                    </ParamFormRow>
                </>
            }
        />
    )
}
